var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path, _circle18, _path2, _circle19, _path3, _circle20, _path4, _rect, _rect2, _path5, _path6, _circle21, _circle22, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 158,
    viewBox: "0 0 164 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.096,
    cy: 34.331,
    r: 1.953,
    transform: "rotate(-54.673 60.096 34.33)",
    fill: "#CCC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.168,
    cy: 53.371,
    r: 1.953,
    transform: "rotate(-54.673 129.168 53.371)",
    fill: "#CCC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.246,
    cy: 40.356,
    r: 1.953,
    transform: "rotate(-54.673 119.246 40.356)",
    fill: "#CCC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.938,
    cy: 32.12,
    r: 1.953,
    transform: "rotate(-54.673 105.938 32.12)",
    fill: "#CCC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.805,
    cy: 27.866,
    r: 1.953,
    transform: "rotate(-54.673 89.805 27.866)",
    fill: "#CCC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.773,
    cy: 41.863,
    r: 1.953,
    transform: "rotate(-54.673 48.773 41.863)",
    fill: "#CCC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.277,
    cy: 51.885,
    r: 1.953,
    transform: "rotate(-54.673 39.277 51.885)",
    fill: "#CCC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.216,
    cy: 64.528,
    r: 1.953,
    transform: "rotate(-54.673 34.216 64.528)",
    fill: "#CCC"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.175,
    cy: 103.536,
    r: 1.953,
    transform: "rotate(-54.673 36.175 103.536)",
    fill: "#CCC"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.346,
    cy: 115.089,
    r: 1.953,
    transform: "rotate(-54.673 42.346 115.089)",
    fill: "#CCC"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.122,
    cy: 125.075,
    r: 1.953,
    transform: "rotate(-54.673 54.122 125.075)",
    fill: "#CCC"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.037,
    cy: 124.238,
    r: 1.953,
    transform: "rotate(-54.673 116.037 124.238)",
    fill: "#CCC"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.398,
    cy: 130.052,
    r: 1.953,
    transform: "rotate(-54.673 101.398 130.052)",
    fill: "#CCC"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.819,
    cy: 112.957,
    r: 1.953,
    transform: "rotate(-54.673 128.819 112.957)",
    fill: "#CCC"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.334,
    cy: 100.111,
    r: 1.953,
    transform: "rotate(-54.673 134.334 100.111)",
    fill: "#CCC"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.69,
    cy: 86.934,
    r: 1.953,
    transform: "rotate(-54.673 137.69 86.934)",
    fill: "#CCC"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.522,
    cy: 85.806,
    r: 9.405,
    transform: "rotate(21.808 29.522 85.806)",
    stroke: "#CCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.773 89.423a4.422 4.422 0 0 1-1.332-.823 2.647 2.647 0 0 1-.777-1.307l1.126-.394c.067.34.223.652.47.935.254.287.55.506.885.659l1.212-3.03a6.104 6.104 0 0 1-.77-.668 3.65 3.65 0 0 1-.568-.794 2.328 2.328 0 0 1-.241-.885 2.36 2.36 0 0 1 .186-1.019 2.352 2.352 0 0 1 1.358-1.352c.305-.118.625-.179.959-.184.337-.013.665.031.985.132l.315-.788.573.23-.316.787c.43.172.82.42 1.17.744.357.328.61.71.758 1.148l-1.074.4a1.994 1.994 0 0 0-.448-.816 1.99 1.99 0 0 0-.778-.546l-1.188 2.97c.277.23.542.466.797.706.254.24.46.498.617.773.169.27.268.564.298.88.039.32-.02.675-.176 1.064a2.406 2.406 0 0 1-1.434 1.405 2.676 2.676 0 0 1-.983.174c-.35-.001-.7-.059-1.052-.172l-.339.847-.572-.229.338-.847zm3.12-7.8c-.418-.085-.797-.047-1.137.112-.33.154-.57.422-.723.804a1.39 1.39 0 0 0-.115.563c.015.171.057.331.127.48a2.3 2.3 0 0 0 .295.436c.13.135.273.275.427.42l1.127-2.815zm-2.176 7.099c.425.115.825.095 1.2-.06.383-.15.651-.417.804-.799.086-.214.121-.417.105-.608a1.328 1.328 0 0 0-.16-.534 1.936 1.936 0 0 0-.355-.46 4.07 4.07 0 0 0-.444-.413l-1.15 2.874z",
    fill: "#CCC"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.863,
    cy: 131.409,
    r: 9.405,
    transform: "rotate(-31.846 78.863 131.409)",
    stroke: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.74 134.962c-.458.285-.942.48-1.452.584a2.642 2.642 0 0 1-1.514-.148l.35-1.14a1.99 1.99 0 0 0 1.032.175 2.627 2.627 0 0 0 1.055-.322l-1.721-2.772c-.33.104-.66.178-.995.225a3.652 3.652 0 0 1-.976-.014 2.33 2.33 0 0 1-.856-.33 2.365 2.365 0 0 1-.71-.754 2.353 2.353 0 0 1-.285-1.895c.086-.316.226-.61.42-.881.19-.279.42-.518.69-.716l-.447-.72.524-.326.447.721a3.777 3.777 0 0 1 1.292-.501 2.71 2.71 0 0 1 1.374.07l-.313 1.102a1.994 1.994 0 0 0-.923-.123 2 2 0 0 0-.901.303l1.688 2.717c.35-.086.696-.16 1.04-.223.345-.063.674-.076.99-.04.317.025.612.119.885.282.28.159.53.416.752.773a2.403 2.403 0 0 1 .282 1.988 2.678 2.678 0 0 1-.442.894c-.209.281-.463.53-.762.746l.481.775-.524.325-.481-.775zm-4.433-7.137c-.316.287-.51.615-.584.983-.071.357.002.71.219 1.059.117.189.246.331.385.426.147.09.3.151.462.182.167.027.343.034.526.021.187-.025.384-.057.592-.095l-1.6-2.576zm4.428 5.961c.344-.275.565-.608.663-1.002.106-.398.05-.772-.167-1.121a1.326 1.326 0 0 0-.427-.445 1.319 1.319 0 0 0-.526-.188 1.9 1.9 0 0 0-.581.013c-.198.022-.397.06-.595.113l1.633 2.63z",
    fill: "#CCC"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.4,
    cy: 29.547,
    r: 9.405,
    transform: "rotate(-6.29 74.4 29.547)",
    stroke: "#CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.56 33.563a4.423 4.423 0 0 1-1.562-.1 2.646 2.646 0 0 1-1.302-.787l.808-.877c.22.269.504.47.855.603.36.133.723.188 1.091.164l-.358-3.243a6.084 6.084 0 0 1-.994-.226 3.65 3.65 0 0 1-.875-.434 2.33 2.33 0 0 1-.629-.667 2.36 2.36 0 0 1-.316-.986 2.35 2.35 0 0 1 .096-1.006c.104-.313.259-.589.465-.827.214-.247.467-.452.76-.613.291-.17.601-.287.93-.349l-.092-.842.613-.068.093.843c.46-.05.92-.015 1.381.106.47.12.873.339 1.21.655l-.759.86a1.992 1.992 0 0 0-.78-.51 1.99 1.99 0 0 0-.943-.115l.35 3.18c.353.072.699.155 1.036.247.338.092.64.223.91.391a2 2 0 0 1 .677.636c.184.264.299.605.345 1.022a2.406 2.406 0 0 1-.603 1.915 2.674 2.674 0 0 1-.785.616c-.31.163-.646.278-1.01.344l.1.907-.612.067-.1-.907zm-.92-8.352c-.41.123-.726.335-.952.635-.218.291-.304.641-.259 1.05.025.221.08.404.164.55.094.145.206.266.338.364a2.3 2.3 0 0 0 .466.246c.179.057.37.114.575.169l-.333-3.014zm1.423 7.288a1.826 1.826 0 0 0 1.03-.618c.267-.313.378-.675.333-1.083a1.334 1.334 0 0 0-.194-.586 1.33 1.33 0 0 0-.392-.396 1.936 1.936 0 0 0-.53-.24 4.079 4.079 0 0 0-.586-.154l.339 3.077z",
    fill: "#CCC"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.336,
    cy: 70.451,
    r: 9.405,
    transform: "rotate(2.084 135.336 70.451)",
    stroke: "#CCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.91 74.447a4.428 4.428 0 0 1-1.531-.326 2.653 2.653 0 0 1-1.173-.968l.927-.75a2 2 0 0 0 .758.721c.336.184.688.29 1.056.321l.118-3.26a6.1 6.1 0 0 1-.95-.37 3.645 3.645 0 0 1-.803-.556 2.313 2.313 0 0 1-.525-.752 2.35 2.35 0 0 1-.169-1.021 2.378 2.378 0 0 1 .822-1.731c.247-.214.528-.38.84-.497.314-.126.637-.195.972-.209l.031-.847.616.022-.031.848c.463.016.913.118 1.352.306.447.188.814.462 1.101.824l-.875.74a1.994 1.994 0 0 0-.698-.617 1.987 1.987 0 0 0-.916-.252l-.116 3.197c.338.123.667.255.988.396.32.14.601.313.842.519a2 2 0 0 1 .578.728c.144.288.208.642.193 1.06-.014.386-.1.73-.256 1.033a2.49 2.49 0 0 1-.62.774 2.674 2.674 0 0 1-.866.496c-.33.116-.68.18-1.049.193l-.033.912-.616-.023.033-.911zm.306-8.396c-.422.061-.767.224-1.034.489-.257.256-.394.59-.409 1-.008.223.019.413.082.57.072.156.165.292.281.408.124.116.266.22.426.311.168.084.349.167.543.251l.111-3.03zm.347 7.417c.438-.036.808-.19 1.109-.461a1.37 1.37 0 0 0 .487-1.024 1.332 1.332 0 0 0-.106-.608 1.326 1.326 0 0 0-.331-.449 1.92 1.92 0 0 0-.49-.313 4 4 0 0 0-.557-.24l-.112 3.095z",
    fill: "#CCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.948,
    y: 70.031,
    width: 39.04,
    height: 25.359,
    rx: 1.218,
    transform: "rotate(-7.544 62.948 70.03)",
    fill: "#EFEFF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.115,
    y: 77.276,
    width: 39.04,
    height: 25.359,
    rx: 1.218,
    transform: "rotate(.009 71.115 77.276)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.416 75.854h-4.671l-1.31-9.891a2.454 2.454 0 0 0-2.738-2.09l-35.4 4.691a2.435 2.435 0 0 0-1.615.94 2.41 2.41 0 0 0-.477 1.799l2.987 22.527a2.435 2.435 0 0 0 2.73 2.098l2.344-.31v5.398a2.436 2.436 0 0 0 2.435 2.436h35.715a2.436 2.436 0 0 0 2.435-2.436V78.289a2.435 2.435 0 0 0-2.435-2.435zm-6.308 0H95.77l6.229-.826.109.826zm-38.296-4.77a.796.796 0 0 1 .16-.595.812.812 0 0 1 .541-.317l35.394-4.69a.823.823 0 0 1 .918.698l.321 2.417-37.014 4.909-.32-2.422zm6.454 22.897-2.553.337a.812.812 0 0 1-.912-.697l-1.81-13.684 5.275-.697v14.742zm.107-16.392-5.6.738-.426-3.21 37.013-4.91.243 1.86.181 1.352-18.368 2.435H72.7a2.435 2.435 0 0 0-2.328 1.734zm38.855 23.427a.812.812 0 0 1-.812.812H72.701a.811.811 0 0 1-.811-.812V78.313c0-.008.004-.016.004-.024 0-.448.363-.812.811-.812h35.711c.448 0 .812.364.812.812v22.727z",
    fill: "#CCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.82 88.048c.326-.24.615-.53.856-.855a4.052 4.052 0 1 0 3.246-6.469 4.044 4.044 0 0 0-3.246 1.649 4.059 4.059 0 1 0-.856 5.675zm4.102-5.7a2.435 2.435 0 1 1 0 4.87 2.435 2.435 0 0 1 0-4.87zm-6.493 0a2.435 2.435 0 1 1 0 4.87 2.435 2.435 0 0 1 0-4.87zM76.76 81.536h-1.624v1.623h1.623v-1.623zM88.123 81.536h-9.74v1.623h9.74v-1.623zM88.123 84.783H75.136v1.623h12.987v-1.623zM105.168 92.088h-29.22a.812.812 0 0 0-.812.812v4.87c0 .448.363.812.811.812h29.221a.811.811 0 0 0 .812-.812V92.9a.811.811 0 0 0-.812-.812zm-.811 4.87H76.759v-3.247h27.598v3.247zM62.993 74.156l38.969-4.895.544 4.329-38.97 4.895z",
    fill: "#CCC"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.461,
    cy: 84.785,
    r: 2.638,
    fill: "#EFEFF0"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.056,
    cy: 84.785,
    r: 2.638,
    fill: "#EFEFF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF0",
    d: "M76.487 93.51h28.206v3.653H76.487z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.ce32b708f38605ab5bdad6bd8d206ca3.svg";
export { ForwardRef as ReactComponent };